import { apiRequest, authRequest } from '../config/api';

// Project API endpoints
export const projectAPI = {
  // Admin endpoints (token required)
  addProject: (projectData) => authRequest('/Project/add', {
    method: 'POST',
    body: JSON.stringify(projectData),
  }),
  
  updateProject: (projectId, projectData) => authRequest(`/Project/update/${projectId}`, {
    method: 'PUT',
    body: JSON.stringify(projectData),
  }),
  
  deleteProject: (projectId) => authRequest(`/Project/delete/${projectId}`, {
    method: 'DELETE',
  }),
  
  toggleActive: (projectId) => authRequest(`/Project/toggle_active/${projectId}`, {
    method: 'POST',
  }),
  
  getAllProjects: () => authRequest('/Project/get_projects', {
    method: 'GET',
  }),
  
  // Public endpoints (no token required)
  getActiveProjects: () => apiRequest('/Project/get_active_projects', {
    method: 'GET',
  }),
  
  getRandomActiveProjects: () => apiRequest('/Project/get_random_active_projects', {
    method: 'GET',
  }),
}; 